import { Foundation } from 'foundation-sites/js/foundation.core';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

export class VideoWithLogo {
    constructor (target) {
      this.section = target;
    }

    init () {
      if (!this.section || CMS.editMode) {
        return;
      }

      Foundation.plugin(Reveal, 'Reveal');

      const modalSelector = $(this.section).find('.video-with-logo-modal');
      const openModalSelector = $(this.section).find('.open-modal');
      const closeModalSelector = $(this.section).find('.close-button');
      const modal = new Foundation.Reveal(modalSelector);

      openModalSelector.on('click', event => {
        event.preventDefault();
        modal.open();
      })

      closeModalSelector.on('click', () => {
        modal.close();
      })

      this.bindModalsListeners();
      this.loading(false);
    }

    bindModalsListeners () {
      $(document).on('closed.zf.reveal', '.video-with-logo-modal', event => {
        const videoPlaceholder = $(event.target).find('.js-video-frame');

        if (videoPlaceholder.length) {
          videoPlaceholder.html('');
        }
      });

      $(document).on('open.zf.reveal', '.video-with-logo-modal', event => {
        const videoPlaceholder = $(event.target).find('.js-video-frame');

        if (!videoPlaceholder.length) {
          return;
        }

        const id = videoPlaceholder.data('id')
        const playlistId = videoPlaceholder.data('playlist')
        const iframe = document.createElement('iframe');

        if (playlistId) {
          iframe.src = playlistId;
        } else {
          iframe.src = `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1`;
        }
        iframe.frameborder = '0';
        iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;

        videoPlaceholder.append(iframe);
      });
    }

    loading(isLoading = true) {
        this.section.classList.toggle('loading', isLoading);
    }
}
